import { createFileRoute } from "@tanstack/react-router";

import { SecuritySettings } from "@/features/settings";

export const Route = createFileRoute("/_authed/_modal/settings/security")({
  component: SecuritySettings,
});
